import styled from 'styled-components'

const Text = styled.p`
  font-size: 1.25rem;
  line-height: 2rem;
  color: ${props => (props.secondary ? '#424750' : '#0E131A')};
`

export default Text
